import React from 'react';
import PropTypes from 'prop-types';
import { Attachments } from '../../../dashboardCommon/components';
import { apiHost } from '../../../../utils/request';

const basePdfLinks = [
  {
    label: 'Proposal PDF',
    getUrl: (orderId, locale) =>
      `${apiHost}/orders/${orderId}/proposal-pdf?lang=${locale}`
  },
  {
    label: 'Quote PDF',
    getUrl: (orderId, locale) =>
      `${apiHost}/orders/${orderId}/quote-pdf?lang=${locale}`
  }
];

const quoteOnlyPdfLinks = [
  {
    label: 'Quote PDF',
    getUrl: (orderId, locale) =>
      `${apiHost}/orders/${orderId}/quote-pdf?lang=${locale}`
  }
];

const Attachements = props => {
  const pdfLinks =
    props.orderData.channelName === 'TQ' ? basePdfLinks : quoteOnlyPdfLinks;
  return (
    <Attachments
      {...props}
      pdfLinks={pdfLinks}
      cardHeaderTitle="Proposal/Quote PDF"
    />
  );
};

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired
};

export default Attachements;
